<template>

    <div class="apply-lab">
        <div class="step-box" :class="{active: currentStep===1}">
            <div class="steps-circle">
                <span class="ab-center">1</span>
            </div>
            <div class="step-line"></div>
            <h6 class="step-title">{{ $t( 'reolinkLab.apply_steps_one_title' ) }}</h6>
            <div class="item-box">
                <div class="item-title">{{$t( 'reolinkLab.device_title' )}}</div>
                <ul class="item-content">
                    <li class="device-item" v-for="(device, index) in labDevices" :key="index">
                        {{device.title}} ({{device.model}}, {{device.uid}})
                    </li>
                </ul>
            </div>
            <div class="item-box">
                <div class="item-title">{{$t( 'reolinkLab.project_title' )}}</div>
                <div class="item-content">{{$t( 'reolinkLab.project_content' )}}</div>
            </div>
            <div class="choice-btns" v-if="currentStep===1">
                <button
                    class="ui-button primary-button short-button"
                    @click="applyLab">
                        {{ $t('reolinkLab.btn_apply') }}
                </button>

                <button
                    class="ui-button empty-button short-button"
                    @click="backToDashboard">
                        {{ $t('reolinkLab.btn_refuse') }}
                </button>
            </div>
        </div>
        <div class="step-box step-two" :class="{active: currentStep===2}">
            <div class="steps-circle">
                <span class="ab-center">2</span>
            </div>
            <h6 class="step-title">{{ $t( 'reolinkLab.apply_steps_two_title' ) }}</h6>
            <p class="status-clue" v-if="isApplied" v-html="$t( 'reolinkLab.success_apply' )"></p>
            <p class="status-clue" v-if="isCanceled" v-html="$t( 'reolinkLab.success_cancel' )"></p>
            <div class="choice-btns" v-if="currentStep===2">
                <button
                    class="ui-button primary-button short-button"
                    v-if="isApplied"
                    @click="cancelLab">
                        {{ $t('reolinkLab.btn_cancel_apply') }}
                </button>
                <button
                    class="ui-button empty-button short-button"
                    @click="backToDashboard">
                        {{ $t('reolinkLab.btn_back_dashboard') }}
                </button>
            </div>
        </div>
        <div class="experiment-intro" v-if="isApplied">
            <h6 class="intro-title">{{ $t('reolinkLab.intro_title') }}</h6>
            <p class="intro-detail">{{ $t('reolinkLab.intro_detail1') }}</p>
            <!-- TODO 111 -->
            <p class="intro-detail" v-html="$t('reolinkLab.intro_detail2', {
                arrow: `<span class='icon-icon_arrow-right'></span>`,
                btnImg: `<img src='${labButton}'/>`
            })"></p>
            <img src="@/common/images/default/lab/experiment-lab.jpg" class="mobile-experiment">
        </div>
    </div>

</template>

<script>
import lab from '@/api/lab.js';
import labButton from '@/common/images/default/lab/button.png';

export default {

    data () {

        return {

            currentStep: 1,
            labButton: labButton

        };

    },

    computed: {

        labInfo () {

            return this.$store.getters.lab;

        },

        isApplied () {

            return this.labInfo.status !== 'inactive' && this.labInfo.enabled;

        },

        isCanceled () {

            return this.currentStep === 2 && this.labInfo.status !== 'inactive' && !this.labInfo.enabled;

        },

        labDevices () {

            return this.$store.getters.labDevices;

        }

    },

    mounted () {

        window.scrollTo( 0, 0 );

    },

    methods: {

        async applyLab () {

            let labData = await lab.applyLab( this.labInfo.id );
            this.$store.commit( 'LAB', labData );

        },

        backToDashboard () {

            this.$emit( 'backToDashboard' );

        },

        async cancelLab () {

            let labData = await lab.cancelLab( this.labInfo.id );
            this.$store.commit( 'LAB', labData );

        }

    },

    watch: {
        isApplied: {

            handler ( n ) {

                if ( n ) {

                    this.currentStep = 2;

                }

            },

            immediate: true
        }
    }
};

</script>

<style scoped type="text/css" lang="less">
@circle_radius: 0.24rem;
@circle_radius_mobile: 0.44rem;
.apply-lab {
    margin-top: 0.6rem;
    margin-bottom: 0.4rem;
    .step-box {
        padding-bottom: 0.6rem;
        position: relative;
        padding-left: 0.64rem;
        font-size: 0.16rem;
        &.step-two {
            border-bottom: 1px solid #ccc;
        }
        &.active {
            .steps-circle {
                background: linear-gradient(150deg, #1e7ff2, #1dc4e4);
                color: #fff;
            }
            .step-title {
                color: #333;
            }
        }
        .steps-circle {
            width: @circle_radius;
            height: @circle_radius;
            border-radius: 100%;
            background-color: #EEE;
            position: absolute;
            top: 0;
            left: 0;
            z-index: 1;
            font-weight: 500;
        }
        .step-line {
            width: 1px;
            height: 100%;
            background-color: #ddd;
            position: absolute;
            top: @circle_radius/2;
            left: @circle_radius/2;
        }
        .step-title {
            font-size: 0.2rem;
            font-weight: 700;
            color: #999;
        }
        .item-box {
            display: flex;
            margin-top: 0.4rem;
            & + .item-box {
                margin-top: 0.3rem;
            }
            .item-title {
                width: 2rem;
                font-weight: 500;
            }
            .item-content {
                flex: 1;
                li + li {
                    margin-top: 0.12rem;
                }
            }
        }
        .choice-btns {
            display: flex;
            margin-top: 0.3rem;
            button {
                margin-right: 0.2rem;
            }
        }
        .status-clue {
            margin-top: 0.2rem;
            /deep/ span {
                color: #E74330;
                font-weight: 500;
            }
        }
    }
    .experiment-intro {
        border-bottom: 1px solid #ccc;
        padding: 0.4rem 0;
        .intro-title {
            font-size: 0.22rem;
            font-weight: 500;
        }
        .intro-detail {
            margin-top: 0.16rem;
            font-size: 0.16rem;
            /deep/ span {
                font-size: 0.12rem;
            }

            /deep/ img {
                width: 0.24rem;
                vertical-align: middle;
            }
        }
        .mobile-experiment {
            display: block;
            margin-top: 0.3rem;
            width: 3.75rem;
        }
    }
    @media @mobile {
        margin-top: 0.6rem;
        margin-bottom: 0.6rem;
        .step-box {
            padding-left: 0.84rem;
            font-size: 0.26rem;
            &.step-two {
                padding-bottom: 0.8rem;
            }
            .steps-circle {
                width: @circle_radius_mobile;
                height: @circle_radius_mobile;
            }
            .step-line {
                top: @circle_radius_mobile/2;
                left: @circle_radius_mobile/2;
            }
            .step-title {
                font-size: 0.36rem;
            }
            .item-box {
                display: block;
                & + .item-box {
                    margin-top: 0.5rem;
                }
                .item-title {
                    width: auto;
                }
                .item-content {
                    margin-top: 0.16rem;
                    li + li {
                        margin-top: 0.16rem;
                    }
                }
            }
            .choice-btns {
                width: max-content;
                flex-direction: column;
                align-items: stretch;
                margin-top: 0.44rem;
                button {
                    min-width: 5.35rem;
                    margin: 0;
                    & + button {
                        margin-top: 0.2rem;
                    }
                }
            }
            .status-clue {
                margin-top: 0.4rem;
            }
        }
        .experiment-intro {
            padding: 0.6rem 0;
            .intro-title {
                font-size: 0.32rem;
            }
            .intro-detail {
                margin-top: 0.24rem;
                font-size: 0.26rem;
                /deep/ span {
                    font-size: 0.2rem;
                }

                /deep/ img {
                    width: 0.44rem;
                }
            }
            .mobile-experiment {
                margin-top: 0.4rem;
                width: 6rem;
            }
        }
    }
}

</style>



// WEBPACK FOOTER //
// src/components/applyLab.vue